import type { MotionEasingToken } from "./motion-timing";

export { duration, delay, spring, stagger } from "./motion-timing";
export type {
  Duration,
  DurationToken,
  Delay,
  DelayToken,
  Spring,
  Stagger,
  StaggerToken,
  MotionEasingToken,
} from "./motion-timing";

export const easing = {
  /** Standard ease-out — starts fast, feels responsive. Default for most UI. */
  standard: "cubic-bezier(0.215, 0.61, 0.355, 1)",

  /** Emphasized ease-in-out — natural for on-screen movement/morphing */
  emphasized: "cubic-bezier(0.645, 0.045, 0.355, 1)",

  /** Linear — constant motion for spinners, progress bars, shimmer */
  linear: "linear",

  /** Decelerate — elements entering the screen */
  decelerate: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",

  /** Accelerate — elements leaving the screen */
  accelerate: "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
} as const satisfies Record<MotionEasingToken, string>;

export type MotionEasing = typeof easing;
